import { mapGetters } from 'vuex'
import flatten from 'lodash/flatten'

export default {
  data() {
    return {
      selectedSegments: flatten(this.getArrayFromQuery('in[segment_ids]'))
    }
  },
  computed: {
    ...mapGetters('site', [
      'segmentsById',
    ]),
    jobsPerPage() {
      return parseInt(this.$store.getters['jobsPerPage'])
    }
  },
  methods: {
    async pageChange(newPage) {
      this.refreshRoute({ ['page']: newPage })
    },
    onSegmentsChange(newSegments) {
      this.selectedSegments = newSegments
      const newQuery = this.getSegmentsQuery(newSegments)
      this.refreshRoute(newQuery, true)
    },
    getSegmentsQuery(newSegments) {
      const segmentsIdsMap = new Map()

      newSegments.forEach(sId => {
        const groupId = this.$store.getters['getSegmentsById'][sId].segment_group_id
        const groupIds = segmentsIdsMap.get(groupId) || []
        groupIds.push(sId)
        segmentsIdsMap.set(groupId, groupIds)
      })

      const groupedSegments = Array.from(segmentsIdsMap.values())
      const querySegments = groupedSegments.map(this.arrayToQuery)
      
      return { ['in[segment_ids]']: querySegments }
    }
  }
}
